var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var BinIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 54,
    glyphHeight: 63
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.5837 7.2118C11.5837 3.22877 14.9766 0 19.1613 0H34.8387C39.0234 0 42.4163 3.22877 42.4163 7.2118H48.7742C51.6601 7.2118 54 9.43859 54 12.1855V13.8434H0V12.1855C0 9.43859 2.33988 7.2118 5.22581 7.2118H11.5837ZM16.2873 7.2118C16.2873 5.70104 17.5737 4.47623 19.1613 4.47623H34.8387C36.4263 4.47623 37.7127 5.70104 37.7127 7.2118H16.2873Z",
    fill: "black"
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M50.5161 16.5789H3.48387L7.34143 58.4607C7.57802 61.0294 9.83801 63 12.5473 63H41.3813C44.0873 63 46.3457 61.0339 46.5864 58.4686L50.5161 16.5789ZM28.3065 25.1754C28.3065 24.0309 27.3316 23.1031 26.129 23.1031C24.9265 23.1031 23.9516 24.0309 23.9516 25.1754V56.1228C23.9516 57.2673 24.9265 58.1952 26.129 58.1952C27.3316 58.1952 28.3065 57.2673 28.3065 56.1228V25.1754ZM41.0374 23.1094C42.2357 23.2057 43.1308 24.2088 43.0367 25.3498L40.4922 56.1951C40.3981 57.3361 39.3503 58.183 38.1521 58.0867C36.9538 57.9904 36.0587 56.9874 36.1528 55.8464L38.6973 25.0011C38.7914 23.86 39.8392 23.0131 41.0374 23.1094ZM14.363 24.9984C14.2674 23.8575 13.2186 23.0118 12.0205 23.1096C10.8223 23.2074 9.92851 24.2116 10.0241 25.3525L12.6078 56.1946C12.7034 57.3355 13.7522 58.1811 14.9503 58.0834C16.1485 57.9856 17.0423 56.9814 16.9467 55.8405L14.363 24.9984Z",
    fill: "black"
  }));
};
export var BinIconGlyph = function (props) {
  return React.createElement(BinIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};